<template>
	<div style="width:90%">

		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
                     <el-form-item label="时间" class='tiny' cleartable>
                        <el-date-picker
                        v-model="dateArr"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :default-time="['00:00:00', '23:59:59']">
                        </el-date-picker>
                    </el-form-item>
					<el-form-item class='tiny'>
						<el-button type="primary" @click="search">查询</el-button>
						<el-button @click="empty">清空</el-button>
					</el-form-item>
					<div style="width: 200px;display: inline-block;"></div>
					<el-form-item class='tiny'>
						<el-button type="primary" @click="editialogVisible('')">新增
						</el-button>
					</el-form-item>

				</el-form>
			</header>
		</div>

		<el-table :data="messageList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column prop="id" label="ID" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="salesNum" label="挂卖笔数" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="salesAmount" label="挂卖金额" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.salesAmount < 10000">{{ scope.row.salesAmount.toFixed(2) }}元</span>
                    <span v-else>{{ (scope.row.salesAmount/10000).toFixed(2) }}万元</span>
                </template>
			</el-table-column>
            <el-table-column prop="purchaseNum" label="买入笔数" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="purchaseAmount" label="买入金额" align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span v-if="scope.row.purchaseAmount < 10000">{{ scope.row.purchaseAmount.toFixed(2) }}元</span>
                    <span v-else>{{ (scope.row.purchaseAmount/10000).toFixed(2) }}万元</span>
                </template>
			</el-table-column>
			<el-table-column prop="otcDate" width="200%" label="日期" align="center">
			</el-table-column>

			<el-table-column  label="操作"  fixed="right" align="center">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id)">编辑</el-button>
					<el-button size="small" type="text" @click="toDelete(scope.row.id)">删除</el-button>
					
				</template>
			</el-table-column>

		</el-table>
		<el-pagination style="margin: 20px;" background :current-page="messageList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="messageList.total" @size-change="handleSizeChange">
		</el-pagination>

		<!-- 编辑、添加 -->
		<el-dialog style="float:rigin" :title="popupTitle" :visible.sync="editDialogVisible" width="30%"
		:close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
                    <el-form-item :label-width="formLabelWidth" label="日期:">
						<template>
							 <el-date-picker
                                v-model="form.otcDate"
                                type="date"
                                format="yyyy 年 MM 月 dd 日"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
						</template>
					</el-form-item>
                    <!-- <el-form-item :label-width="formLabelWidth" label="类型:">
						<template>
							<el-radio-group v-model="type">
                                <el-radio :label="0">挂卖</el-radio>
                                <el-radio :label="1">买入</el-radio>
                            </el-radio-group>
						</template>
					</el-form-item> -->
					<el-form-item :label-width="formLabelWidth" label="挂卖笔数:">
						<template>
							<el-input type="number" v-model.number="form.amountSale" placeholder="请输入内容" 
                            style="width:220px"></el-input>
						</template>
					</el-form-item>
                    <el-form-item :label-width="formLabelWidth" label="挂卖金额:">
						<template>
							<el-input type="number" v-model.number="form.sumSale" placeholder="请输入内容"
                            style="width:220px"></el-input>
						</template>
					</el-form-item>
                    <el-form-item :label-width="formLabelWidth" label="买入笔数:">
						<template>
							<el-input type="number" v-model.number="form.amountBuy" placeholder="请输入内容" 
                            style="width:220px"></el-input>
						</template>
					</el-form-item>
                    <el-form-item :label-width="formLabelWidth" label="买入金额:">
						<template>
							<el-input type="number" v-model.number="form.sumBuy" placeholder="请输入内容"
                            style="width:220px"></el-input>
						</template>
					</el-form-item>
					<el-form-item>
						<el-button :loading="loading" type="primary" @click="toEdit()">提交</el-button>
						<el-button @click="editDialogVisible = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	
	export default {
		components: {

		},
		data() {
			return {
				popupTitle:'新增',
				dateArr: [],
				loading: false,
				messageList: [], //消息
                editDialogVisible: false,
                // editDialogVisibleUpd: false
                searchInfo:{},
                type: 0,
				form: {
                    otcDate: '',
                    amountSale: 0,
                    sumSale: 0,
                    amountBuy: 0,
                    sumBuy: 0
                },
                formLabelWidth: "200px",
                mainFormRules: {
					title: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
                },
                page: {
					pageNum: 1,
					pageSize: 10
			    },
			};
		},
		computed: {
		
		},
		methods: {
			
			empty() {
				this.dateArr = [];
				this.searchInfo.startTime = ''
                this.searchInfo.endTime = ''
			},
			search() {
                if(this.dateArr.length>0){
                    this.dateArr.forEach((item,index) => {
                    this.dateArr.splice(index,1,this.$moment(item).format('YYYY-MM-DD HH:mm:ss'))
                    })
                    this.searchInfo.startTime = this.dateArr[0]
                    this.searchInfo.endTime = this.dateArr[1]
                }
                this.page.pageNum = 1;
                this.getMessageList()
				// this.loading = true;
				// this.page.title = this.title ? this.title : null;
				// let webData = {
				// 	pageNum: 1,
				// 	pageSize: this.page.pageSize,
				// 	title: this.title ? this.title : null
				// }
				// this.$api.selMessageList(webData).then((res) => { //角色管理列表
				// 	if (res.state == 'success') {
				// 		this.messageList = res.data
				// 	}
				// 	this.loading = false
				// })
			},

			
			//编辑弹框
			editialogVisible(id) {
				if (id) {
					//编辑查询
					this.popupTitle = '编辑'
					this.ids = id
					this.$api.getIdOtcList(id).then((res) => { //通过id查询消息
						console.log(res);
						if (res.state == 'success') {
                            // this.form = res.data;
                            this.form.otcDate = res.data.otcDate;
                            this.form.sumSale = res.data.salesAmount;
                            this.form.amountSale = res.data.salesNum;
                            this.form.sumBuy = res.data.purchaseAmount;
                            this.form.amountBuy = res.data.purchaseNum;
						}
					})
				} else {
					this.popupTitle = '新增'
					this.ids = ""
					this.form = {}
				}
				this.editDialogVisible = true;
			},
			toEdit() {
                console.log('112--',this.form)
				if (this.ids) {
					//编辑
                    let data = {
						id: this.ids,
                        otcDate: this.form.otcDate,
                        purchaseAmount: this.form.sumBuy,
                        purchaseNum: this.form.amountBuy,
                        salesAmount: this.form.sumSale,
                        salesNum: this.form.amountSale
                    }
                    // if(this.type == 0){ //挂卖
                    //     data = {
                    //         otcDate: this.form.otcDate,
                    //         salesAmount: this.form.sum,
                    //         salesNum: this.form.amount
                    //     }
                    // }else{ //买入
                    //     data = {
                    //         otcDate: this.form.otcDate,
                    //         purchaseAmount: this.form.sum,
                    //         purchaseNum: this.form.amount
                    //     }
                    // }
					this.$api.updateOtcList(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
					})
				} else {
					//添加
                    this.loading = true
                    let data = {
                        otcDate: this.form.otcDate,
                        purchaseAmount: this.form.sumBuy,
                        purchaseNum: this.form.amountBuy,
                        salesAmount: this.form.sumSale,
                        salesNum: this.form.amountSale
                    }
                    // let data;
                    // if(this.type == 0){ //挂卖
                    //     data = {
                    //         otcDate: this.form.otcDate,
                    //         salesAmount: this.form.sum,
                    //         salesNum: this.form.amount
                    //     }
                    // }else{ //买入
                    //     data = {
                    //         otcDate: this.form.otcDate,
                    //         purchaseAmount: this.form.sum,
                    //         purchaseNum: this.form.amount
                    //     }
                    // }
					
					console.log('传递参数--',data);
					this.$api.addOtcList(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.editDialogVisible = false;
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
						this.loading = false
					})
				}
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			
			pageChange(data) {
				this.page.pageNum = data
				this.getMessageList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getMessageList()
			},
			getMessageList() {
				this.loading = true
                // let data = this.page;
                let data = Object.assign(this.searchInfo,this.page)
				this.$api.getOtcList(data).then((res) => { //消息
					console.log('表格数据--',res);
					if (res.state == 'success') {
						this.messageList = res.data
						this.loading = false
					}
				})
			},
		
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delectOtcList(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getMessageList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			
		},
		created() {
			this.getMessageList();
			// this.getMessageTypeList();
		},
		mounted: function () { },
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
		margin-left: 30px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}

	.lpc-quill img {
		width: 100px;
		height: 120px;
	}

	.lpc-quill-en img {
		width: 100px;
		height: 120px;
	}
</style>